/* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';
import {Button, Col, Panel, Row} from 'react-bootstrap';
import { connect } from 'react-redux';
import { Field, Form, propTypes, reduxForm } from 'redux-form';
import { remove as removeAction, save as saveAction } from '../../../../reducers/employees/employees.actions';
import { isLocal } from '../../../../reducers/localId/localId';
import JobFormGroup from '../../../Forms/JobFormGroup/JobFormGroup';
import TTFormGroup from '../../../Forms/TTFormGroup/TTFormGroup';
import SpinnerButton from '../../../SpinnerButton/SpinnerButton';
import UnsavedChangesPrompt from '../../../UnsavedChangesPrompt/UnsavedChangesPrompt';
import './EmployeeForm.css';

// eslint-disable-next-line object-curly-newline
export class EmployeeForm extends React.Component {
  constructor() {
    super();
    this.state = {
      showFields: false,
    };
  }

  render() {
    const {submitting, dirty, remove, save, initialize, handleSubmit, employee: {name, removing, id}} = this.props;

    return (
      <span>
      <Row style={{'margin-top': "-14px"}}>
        <Col md={1}><Button style={{'height': "14px", "padding": "5px 15px 20px 15px", "font-size": "14px"}} onClick={() => this.setState({showFields: !this.state.showFields})}>Edit</Button></Col>
        <Col md={11} style={{'font-size': "14px"}}>{name}</Col>
      </Row>
      <Panel>
        {dirty && <UnsavedChangesPrompt dirty/>}
        {(this.state.showFields || id.toString().includes('LOCAL')) &&
        <Form
          onSubmit={
            handleSubmit(values =>
              save(values, id)
                .then(client => initialize(client.response)))}
        >
          <Row>
            <Col md={4}>
              <Field
                component={TTFormGroup}
                name="name"
                label="Name"
                type="text"
                required
              />
            </Col>
            <Col md={4}>
              <Field
                component={TTFormGroup}
                name="email"
                label="Email"
                type="text"
              />
            </Col>
            <Col md={2}>
              <Field
                component={JobFormGroup}
                name="role"
                label="Job"
                type="text"
                required
              />
            </Col>
            <Col md={2}>
              <Field
                component={TTFormGroup}
                name="no_stats"
                label="No Stats"
                type="checkbox"
                required
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Field
                component={TTFormGroup}
                name="username"
                label="Username"
                type="text"
              />
            </Col>
            <Col md={6}>
              <Field
                component={TTFormGroup}
                name="password"
                label="Password"
                type="password"
              />
            </Col>
          </Row>
          <Row>
            <Col xs={6} md={2}>
              <SpinnerButton
                isLoading={submitting}
                type="submit"
                dirty={dirty}
              >
                {isLocal(id) ? 'Add' : 'Save'}
              </SpinnerButton>
            </Col>
            <Col xs={6} md={2}>
              {/*<SpinnerButton*/}
                {/*isLoading={removing}*/}
                {/*onClick={() => remove(id)}*/}
                {/*bsStyle="danger"*/}
              {/*>*/}
                {/*Remove*/}
              {/*</SpinnerButton>*/}
            </Col>
          </Row>
        </Form>
        }
      </Panel></span>);
  }
}

EmployeeForm.propTypes = {
  ...propTypes,
  employee: PropTypes.shape({
    isRemoving: PropTypes.bool.isRequired,
  }).isRequired,
};

export const mapStateToProps = (state, ownProps) => ({
  initialValues: ownProps.employee,
  form: `employee${ownProps.employee.id}`,
});

export const mapDispatchToProps = dispatch => ({
  remove: id => dispatch(removeAction(id)),
  save: (values, id) => dispatch(saveAction({ employee: { ...values, id }, id })),
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({ enableReinitialize: true })(EmployeeForm));



// WEBPACK FOOTER //
// ./src/components/Admin/Employees/EmployeeForm/EmployeeForm.jsx